export const pagesActions = {
  default: {
    fullControl: 'fullControl',
    create: 'create',
    update: 'update',
    delete: 'delete',
  },
  formApplicant: {
    canComplete: 'canComplete',
    canViewInfos: 'canViewInfos',
    canWithdrawal: 'canWithdrawal',
    canSesmtValidate: 'canSesmtValidate',
    canDocumentValidate: 'canDocumentValidate',
    canViewAdmissionExamsAction: 'canExamsAction',
    canSeeInsights: 'canSeeInsights',
  },
  hourlyBasis: {
    canAddBatch: 'addBatch',
    canReview: 'review',
    canViewList: 'viewList',
    canViewActions: 'viewActions',
  },
  outsourced: {
    canViewDetails: 'canViewDetails',
    canEditCompany: 'canEditCompany',
    canDesactivate: 'canDesactivate',
    canIncludeDoc: 'canIncludeDoc',
    viewSettings: 'viewSettings',
    canIncludeProvider: 'canAddProvider',
    canExportProviders: 'exportProviders',
  },
  exitInterview: {
    canSeeCustomSearch: 'seeCustomSearch',
    canSeeComments: 'seeComments',
    canSeeInsights: 'seeInsights',
    canSeeInterviews: 'seeInterviews',
    excludeFromInterviews: 'excludeFromInterviews',
    reopenInterview: 'reopenInterview',
  },
  employeeManagements: {
    canViewExceptions: 'canViewExceptions',
    canViewExcusedAbsences: 'canViewExcuseds',
    canViewTimeShiftHistory: 'canViewTimeHistory',
    canViewBonusReasonsWithoutDocs: 'viewWithoutDocs',
    canViewOvertimes: 'canViewOvertimes',
    canViewExcusedEvidences: 'canViewExcusedEvidences',
    canSyncOccurrencesManual: 'canSyncOccurrencesManual',
    canChangeEvidence: 'canChangeEvidence',
    canCreateOwnAbsences: 'canCreateOwnAbsences',
    canAccessFeedbackSettings: 'canAccessFeedbackSettings',
    canQualifyExcusedAbsences: 'canQualifyExcusedAbsences',
  },
  employees: {
    canPerformResignation: 'performResignation',
  },
  formCompanies: {
    canAddRoot: 'canAddRoot',
    canAddOrgs: 'canAddOrgs',
    canAddFacility: 'canAddFacility',
    canUpdateRoot: 'canUpdateRoot',
    canUpdateOrgs: 'canUpdateOrgs',
    canUpdateFacility: 'canUpdateFacility',
  },
  insights: {
    canViewAll: 'canViewAll',
    exportEvents: 'exportEvents',
    canViewClosingValues: 'canViewClosingValues'
  },
  profile: {
    preHandling: 'preHandling',
    canViewNews: 'canViewNews', // visualizar notificações na navbar (sem url própria)
  },
  vacation: {
    canViewAll: 'canViewAll',
    canManagePartially: 'canManagePartially',
    canRequestPartially: 'canRequestPartially',
  },
  probationaryPeriod: {
    fullControl: 'fullControl',
    canFillManagerForm: 'canFillManagerForm',
    canFillEmployeeForm: 'canFillEmployeeForm',
    canFillFinalDecision: 'canFillFinalDecision',
    canAddAndUpdateSettings: 'canAddAndUpdateSettings',
    canViewEvaluations: 'canViewEvaluations',
    canViewMetrics: 'canViewMetrics',
  },
  jobtitle: {
    viewAndManageSalaries: 'viewAndManageSalaries',
    manageSalaryRanges: 'manageSalaryRanges',
  },
  ethicsChannel: {
    fullControl: 'fullControl',
    manageSettings: 'manageSettings',
  },
  avd: {
    fullControl: 'fullControl',
    manageReviews: 'manageReviews',
    manageQuestionBank: 'manageQuestionBank',
    manageSettings: 'manageSettings',
  },
  workforcePlan: {
    canManageFlows: 'canManageFlows',
    canManageEmploymentContractInformation: 'manageEmploymentContractInformation'
  },
  offboarding: {
    canSeeIAInsights: 'canSeeIAInsights',
  },
};
